<template>
    <div >
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-app class="no-background" style="background-color: #F9F5F6;">
            <transition>
                <router-view />
            </transition>
        </v-app>

        <!-- <div id="quick_link_slider" v-if="quick_links" class="quick-link-slider-box">
            <div class="quick-link-icon no-display">
                <v-icon large color="orange darken-2" class="icon-quick" @click="sliderCloseOpen(false)" v-if="isClosed" title="Quick Links">mdi-arrow-left-bold-box </v-icon>
                <v-icon large color="orange darken-2" class="icon-quick" @click="sliderCloseOpen(true)" v-if="!isClosed" title="Quick Links">mdi-arrow-right-bold-box </v-icon>
            </div>

            <div style="position: relative; top: -35px; overflow-y: scroll; height: 100%;">
                <v-list dense>
                    <v-subheader style="font-size: 18px;"> Quick Links </v-subheader>
                    <v-btn fab dark x-small class="quick-link-add-btn" @click.native="openDialog()" style="background-color: #4caf50;">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>

                    <v-list-item-group color="primary">
                        <router-link to="/home" class="sidebar-link" @click.native="sliderCloseOpen(true)">
                            <v-list-item link>
                                <v-list-item-icon>
                                    <v-icon>mdi-home</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title style="font-size: 1rem;">Home</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </router-link>
                        <v-divider></v-divider>

                        <div v-for="(qlink, index) in quicklinkslist" :key="index">
                            <router-link :to="{ name: qlink.link }" class="sidebar-link" @click.native="sliderCloseOpen(true)">
                                <v-list-item link>
                                    <v-list-item-icon>
                                        <v-icon>{{ qlink.icon }}</v-icon>
                                    </v-list-item-icon>

                                    <v-list-item-content>
                                        <v-list-item-title style="font-size: 1rem;">{{ qlink.name }}</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action class="delete-quick-link-div">
                                        <v-icon icon class="delete-quick-link-btn" @click.native="deleteQuickLink(qlink)" style="color: grey;" title="delete links">delete</v-icon>
                                    </v-list-item-action>
                                </v-list-item>
                            </router-link>

                            <v-divider></v-divider>
                        </div>
                    </v-list-item-group>
                </v-list>
            </div>
        </div> -->
        <!-- End of Quick Link Div --->
        <!-- style="position: fixed; top: -1020px;margin-left:1490px; height: 100%;" -->
        <!-- <div class="quick-link-slider-box1" v-if="calendar_flag">
            <div class="quick-link-icon no-display">
                <v-icon large color="orange darken-2" @click="getCalandar" title="My Calendar">mdi-calendar-check </v-icon>
            </div>
        </div>
        <div class="quick-link-slider-box3" v-if="calendar_flag">
            <div class="quick-link-icon no-display">
                <v-icon large color="orange darken-2" @click="dialog_speechtotext = true" title="Speech To Text">mdi-microphone </v-icon>
            </div>
        </div>
        <div class="quick-link-slider-box4" v-if="calendar_flag">
            <div class="quick-link-icon no-display">
                <v-icon large color="orange darken-2" @click="openeditor()" title="Editor">mdi-file-edit-outline</v-icon>
            </div>
        </div> -->
        <!-- <v-dialog v-model="dialog_calendar" width="1000px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-toolbar class="toolbar" flat dense>
                            <v-btn icon dark @click="dialog_calendar = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>My Calendar</v-toolbar-title>
                        </v-toolbar>
                    </v-card>

                    <v-card class="box">
                        <instructor-calendar :events="events"></instructor-calendar>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog> -->

        <!-- <v-dialog v-model="dialog_speechtotext" width="1000px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-toolbar class="toolbar" flat dense>
                            <v-btn icon dark @click="dialog_speechtotext = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>Speech To Text</v-toolbar-title>
                        </v-toolbar>
                    </v-card>

                    <v-card class="box">
                        <speech-to-text></speech-to-text>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog> -->
        <!-- <v-dialog v-model="dialog_Editor" width="1000px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-toolbar class="toolbar" flat dense>
                            <v-btn icon dark @click="dialog_Editor = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>Editor</v-toolbar-title>
                        </v-toolbar>
                    </v-card>
                    <v-card class="box">
                        <v-row dense justify="center">
                        <v-col cols="12" sm="9" md="9">
                            <ckeditor v-model="textEditor" :config="editorConfig"></ckeditor>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" v-if="textEditor">
                            <span><v-icon class="icon-quick" title="Copy text" @click="copy(textEditor)">mdi-content-copy</v-icon></span>
                        </v-col>
                    </v-row>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog> -->

        <!-- today's data shown -->

        <div id="quick_link_slider1" v-if="today_events" class="quick-link-slider-box2">
            <!-- <div class="quick-link-icon no-display">
                <v-icon
                    large
                    color="orange darken-2"
                    class="icon-quick"
                    @click="
            todayCloseOpen(false);
            todayEvents();
          "
                    v-if="isToday"
                    title="Today's Events"
                >
                    mdi-calendar-star
                </v-icon>
                <v-icon large color="orange darken-2" class="icon-quick" @click="todayCloseOpen(true)" v-if="!isToday" title="Today events here">mdi-calendar-arrow-right </v-icon>
            </div> -->

            <div style="position: relative; top: -35px; overflow-y: scroll; height: 100%;">
                <v-list dense style="background-color: lemonchiffon;">
                    <v-subheader style="font-size: 21px;"> Today's Events </v-subheader>

                    <v-list-item-group color="primary">
                        <router-link to="/home" class="sidebar-link" @click.native="todayCloseOpen(true)">
                            <!-- <v-card class="box">
                <v-toolbar class="toolbar" flat dense>
                  <v-toolbar-title>Time Table</v-toolbar-title>
                </v-toolbar>
                <v-card
                  class="back-hover"
                  v-for="(sub, i) in timeTable_list"
                  :key="i"
                >
                  <span> {{ sub.tt_course }}</span>
                  <span style="margin-left: 5px"> {{ sub.tt_std }}</span>
                  <span> {{ sub.tt_div }}</span
                  ><br />
                  <span> {{ sub.tt_web_link }}</span
                  ><br />
                  <span> {{ sub.tt_slot }} - {{ sub.tt_slot_end_time }}</span>
                </v-card>
              </v-card> -->
                        </router-link>
                        <v-divider></v-divider>
                    </v-list-item-group>
                </v-list>
                <div class="t-data" v-if="timeTable_list.length > 0">
                    <center>
                        <h2>Time Table</h2>
                    </center>
                    <div v-for="(sub, i) in timeTable_list" :key="i">
                        <span style="margin-left: 5px;"> {{ sub.tt_course }}</span>
                        <span style="margin-left: 5px;"> {{ sub.tt_std }}</span>
                        <span> {{ sub.tt_div }}</span>
                        <span> {{ sub.tt_slot }} - {{ sub.tt_slot_end_time }}</span>
                    </div>
                    <v-divider></v-divider>
                </div>

                <div class="t-data1" v-if="birthday_list.length > 0">
                    <center>
                        <h2>Birthday</h2>
                    </center>

                    <div v-for="(bday, i) in birthday_list" :key="i">
                        <v-icon color="orange darken-2" v-if="bday.usertype == 'Employee'">mdi-account-tie employee</v-icon>
                        <v-icon color="orange darken-2" v-else>mdi-account student</v-icon>
                        <span style="margin-left: 5px;"> {{ bday.name }}</span>
                        <!-- <span style="margin-left: 5px"> {{ bday.usertype }}</span> -->
                    </div>
                    <v-divider></v-divider>
                </div>
            </div>
        </div>

        <!-- today's data end -->
        <!-- today's dialog -->

        <!-- today's dialog end -->
        <!-- Quick Link Add Model -->
        <v-dialog v-model="dialog" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Add Quick Link
                </v-card-title>

                <v-card-text v-if="all_role_links != null">
                    <v-row>
                        <v-col cols="12">
                            <v-combobox v-model="add_link" :items="all_role_links" item-text="linkname" item-value="id" label="Add Quick links" return-object multiple chips clearable> </v-combobox>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer> </v-spacer>
                    <v-btn color="primary" text @click="cancelDialog()" outlined>
                        Cancel
                    </v-btn>
                    <v-btn color="primary" @click="saveQuickLinks">Add</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- End Quick Link Add Model -->
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    // import instructor_calendar from "./components/Academics/AcademicPlanner/InstructorCalendar";
    // import SpeechToText from "./components/TryNError/SpeechToText";
    // import Editer from "./components/Editer";

    export default {
        name: "App",

        components: {
            //   "instructor-calendar": () => import('./components/Academics/AcademicPlanner/InstructorCalendar'),
        // "speech-to-text": () => import('./components/TryNError/SpeechToText'),
        // "editer": () => import('./components/Editer'),
        },

        data: () => ({
          editorConfig: {
        height: "100px",
        extraPlugins: "mathjax",
        mathJaxLib:
          "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
      },
            isClosed: true,
            textEditor:null,
            isToday: true,
            dialog: false,
            quick_links: false,
            calendar_flag: false,
            today_events: false,
            snackbar_msg: "",
            color: "",
            dialog_calendar: false,
            dialog_speechtotext: false,
            dialog_Editor:false,
            timeTable_list: [],
            birthday_list: [],
            snackbar: false,
            quicklinkslist: null,
            all_role_links: null,
            //2
            add_link: [],
            events: [],
            stud: "",
        }),
        updated: function () {
    this.$nextTick().then(() => {
      if (window.MathJax) {
        window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
          console.log("done")
        );
      }
    });
  },
    mounted(){
        fetch('https://api.ipify.org?format=json')
            .then(x => x.json())
            .then(({ ip }) => {
                // alert(ip)
                localStorage.setItem("myip",ip)
            });
        this.waitAndApply()
    },
        methods: {
            waitAndApply() {

                const lang = localStorage.getItem("preferred_lang");

                if (!lang || lang === "en") {
                    document.cookie = "googtrans=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                    return;
                }

                let attempts = 0;

                const interval = setInterval(() => {

                    const select = document.querySelector(".goog-te-combo");

                    if (select) {
                        select.value = lang;
                        select.dispatchEvent(new Event("change"));
                        clearInterval(interval);
                        this.hideTranslateBar();
                    }

                    attempts++;

                    if (attempts > 10) {
                        clearInterval(interval);
                    }

                }, 400);
            },
            hideTranslateBar() {
                const banner = document.querySelector(".goog-te-banner-frame");
                if (banner) banner.style.display = "none";
                document.body.style.top = "0px";
            },
            openeditor(){
                let routeData = this.$router.resolve({
                name: "editor",
            });
            window.open(routeData.href, "_blank");
            },
            todayEvents() {
                this.$store.commit("settoday_events", this.$store.state.today_events);
                // alert("in today func");
                // getInstructorTodayData
                var url = null;
                if (localStorage.getItem("EPS-ut") == "Employee") {
                    url = "communication/getInstructorTodayData";
                }
                // else if (localStorage.getItem("EPS-ut") == "Student")
                //   url = "communication/getLearnerTodayData";
                else return;

                axios
                    .get(url)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.timeTable_list = res.data.time_table_data;
                            // console.log("time table data", this.timeTable_list);
                            this.birthday_list = res.data.birthday_data;
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },
            getCalandar() {
                this.dialog_calendar = true;
                this.todayCloseOpen(true);
                this.sliderCloseOpen(true);
                this.$store.commit("setcalendar_flag", this.$store.state.calendar_flag);
                this.events = new Date();
                axios
                    .get("communication/getInstructorDateData")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.inst_data.length !== null) {
                                this.events = res.data.inst_data;
                                console.log(this.events);
                            }
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },
            copy(text) {
                navigator.clipboard.writeText(text);
                //   alert("Text copied to clipboard!!!");
                this.showSnackbar("#4caf50", "Text copied to clipboard!!!");
            },
            openDialog() {
                //location.reload();
                this.dialog = true;
            },
            cancelDialog() {
                this.dialog = false;
                this.sliderCloseOpen(true);
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            sliderCloseOpen(val) {
                var quickslidediv = document.getElementById("quick_link_slider");
                //console.log("sliderCloseOpen>>" + val);
                if (val) {
                    quickslidediv.style.right = "-280px";
                    //console.log("IF>>" + quickslidediv.style.right);
                    this.isClosed = true;
                } else {
                    if (localStorage.getItem("EPS-ut") != "Parent") {
                        this.todayCloseOpen(true);
                    }
                    // this.todayCloseOpen(true);

                    this.isClosed = false;

                    quickslidediv.style.right = "0px";
                    //console.log("ELSE>>" + quickslidediv.style.right);
                }
            },
            todayCloseOpen(val) {
                var quickslidediv = document.getElementById("quick_link_slider1");
                //console.log("sliderCloseOpen>>" + val);
                if (val) {
                    quickslidediv.style.right = "-280px";
                    //console.log("IF>>" + quickslidediv.style.right);

                    this.isToday = true;
                } else {
                    this.sliderCloseOpen(true);
                    this.isToday = false;

                    quickslidediv.style.right = "0px";
                    //console.log("ELSE>>" + quickslidediv.style.right);
                }
            },
            deleteQuickLink(qlink) {
                const formData = {
                    qlinkid: qlink.id,
                };
                axios
                    .post("roleManagement/deleteQuickLinks", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.quicklinkslist = res.data.quick_links;
                            this.all_role_links = res.data.all_role_links;
                            this.showSnackbar("#b71c1c", "Deleted successfully..."); // show snackbar on success
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
                //alert("Delete " + qlink.id);
            },
            saveQuickLinks() {
                if (this.add_link.length == 0) {
                    //alert("Please select")
                    this.showSnackbar("#b71c1c", "Please select"); // show snackbar on success
                    return;
                }
                axios
                    .post("roleManagement/saveQuickLinks", this.add_link)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.quicklinkslist = res.data.quick_links;
                            this.all_role_links = res.data.all_role_links;
                            this.sliderCloseOpen(false);
                            this.dialog = false;
                            this.showSnackbar("#4caf50", "Quick Link added successfully..."); // show snackbar on success
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            //
        },
        watch: {
            "$store.state.quick_links": function () {
                this.quick_links = this.$store.state.quick_links;
                let uid = localStorage.getItem("EPS-uid");
                if (uid != "admin@eps.com") {
                    axios
                        .post("roleManagement/getUserRoleLinks")
                        .then((res) => {
                            if (res.data.msg == "200") {
                                this.quicklinkslist = res.data.quick_links;
                                this.all_role_links = res.data.all_role_links;
                                // console.log("all_role_links>>"+this.all_role_links)
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        })
                        .finally(() => {});
                }
            },
            "$store.state.calendar_flag": function () {
                this.calendar_flag = this.$store.state.calendar_flag;
                if (localStorage.getItem("EPS-uid")) {
                    if (localStorage.getItem("EPS-ut") != "Employee") {
                        this.$store.commit("setcalendar_flag", false);
                    }
                }
            },
            "$store.state.today_events": function () {
                this.today_events = this.$store.state.today_events;
                if (localStorage.getItem("EPS-uid")) {
                    if (localStorage.getItem("EPS-ut") == "Parent") {
                        this.$store.commit("settoday_events", false);
                    }
                }
            },
            $route() {
                const lang = localStorage.getItem("preferred_lang");
                if (lang && lang !== "en") {
                    this.waitAndApply();
                }
            }
        },
    };
</script>
<style scoped>
    .quick-link-slider-box1 {
        border: 1px solid #0000001f;
        position: fixed;
        top: 15%;
        right: -255px;
        width: 256px;
        height: 91%;

        background-color: white;
        transition-duration: 0.1s;
        transition-delay: 0.2s;
    }

    .quick-link-slider-box3 {
        border: 1px solid #0000001f;
        position: fixed;
        top: 27%;
        right: -255px;
        width: 256px;
        height: 91%;

        background-color: white;
        transition-duration: 0.1s;
        transition-delay: 0.2s;
    }
    .quick-link-slider-box4 {
        border: 1px solid #0000001f;
        position: fixed;
        top: 32%;
        right: -255px;
        width: 256px;
        height: 91%;

        background-color: white;
        transition-duration: 0.1s;
        transition-delay: 0.2s;
    }

    .quick-link-slider-box {
        border: 1px solid #0000001f;
        position: fixed;
        top: 9%;
        right: -280px;
        width: 280px;
        height: 91%;

        background-color: white;
        transition-duration: 0.1s;
        transition-delay: 0.2s;
    }
    .quick-link-slider-box2 {
        border: 1px solid #0000001f;
        position: fixed;
        top: 21%;
        right: -280px;
        width: 280px;
        height: 91%;

        background-color: white;
        transition-duration: 0.1s;
        transition-delay: 0.2s;
        /* overflow:hidden; */
    }
    .theme--light.v-icon {
        color: orange;
    }
    .quick-link-icon {
        text-align: center;
        width: 28px;
        height: 28px;
        position: relative;
        left: -28px;

        transition-duration: 0.1s;
        transition-delay: 0.2s;
    }
    .sidebar-link {
        text-decoration: none;
    }
    .sidebar-link-item:hover {
        background-color: rgb(181, 186, 190) !important;
    }
    .quick-link-add-btn {
        position: absolute;
        right: 4px;
        top: 8px;
    }
    @media print {
        body {
            height: 100%;
            width: 100%;
        }
        .no-display {
            display: none !important;
        }
        .no-background{
            background-color: white !important;
        }
    }
    .back-hover {
        border-radius: 16px !important;
        height: 75px;
        margin: 5px;
        padding-left: 10px;
    }
    .back-hover:hover {
        box-shadow: 20px 20px 20px grey !important;
        -webkit-transition: box-shadow 0.3s ease-in !important;
    }

    .back-hover span {
        font-size: 20px;
        font-weight: 500;
    }
    .t-data span {
        font-size: 20px;
    }
    .t-data {
        background-color: #65f9c7;
    }
    .t-data1 span {
        font-size: 20px;
    }
    .t-data1 {
        background-color: #b9ddf9;
    }
</style>
